import {
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import {
  PageLoad,
  // FormSubmit,
  // CustomlinksInteracted,
  // DocumentDownload,
  // SearchResults,
  // SearchResultsCTA,
  // VideoInteracted
} from './eventData';
import { assign, isEmpty, trim, clone, nth } from 'lodash-es';
import { usePageStore } from "~/stores/page";
import { useUser } from '~/modules/customer/composables/useUser';
export const useGtm = () => {
  const { app, $config } = useContext();
  const route = useRoute();
  const {
    load,
    user,
    isAuthenticated,
  } = useUser();
  const gtmPushEvent = (eventName, data) => {
    app.$gtm.push({
      event: eventName,
      ...data
    });
  };

  const eventPageLoad = async () => {
    if (isAuthenticated.value) {
      await load();
    }
    const { pageData } = usePageStore();
    const defaultData = {
      "Productview": pageData.pageName,
      "pageURL": decodeURI(route.value.fullPath),
      "siteCountry": "CN",
      "sitelanguage": "zh-CN",
      "pageLoadTime": new Date().toDateString(),
      "pageName": pageData.pageName,
      "pageTitle": pageData.pageTitle,
      "pageCategory": pageData.pageCategory,
      "breadCrumbs": pageData.breadCrumbs,
      "deviceType": app.$device.isDesktop ? "Desktop": "Mobile",
      "environment": trim($config.baseUrl, 'https://'),
      "hostName": $config.baseUrl,
      "industryView": isEmpty(pageData.breadCrumbs[2])?"": pageData.breadCrumbs[2],
      "productCategoryView": nth(pageData.breadCrumbs, -2)?nth(pageData.breadCrumbs, -2):'',
      "pageType": clone(pageData.breadCrumbs).pop(),
      "prevPage": clone(pageData.breadCrumbs).pop(),
      "referringURL": document.referrer?document.referrer:'',
      "userInfor": user.value ? user.value.id_hash : '',
      "contentHierarchy": {
        "level1": isEmpty(pageData.breadCrumbs[0])?"": pageData.breadCrumbs[0],
        "level2": isEmpty(pageData.breadCrumbs[1])?"": pageData.breadCrumbs[1],
        "level3": isEmpty(pageData.breadCrumbs[2])?"": pageData.breadCrumbs[2],
        "level4": isEmpty(pageData.breadCrumbs[3])?"": pageData.breadCrumbs[3],
        "level5": isEmpty(pageData.breadCrumbs[4])?"": pageData.breadCrumbs[4],
      }
    };
    const PageLoadData = { ...PageLoad };
    gtmPushEvent('PageLoad', { data: assign(PageLoadData, defaultData) });
  };

  const eventCustomlinksInteracted = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "eventAction": "Click",
    //   "eventCategory": "Default links",
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // const CustomlinksInteractedData = { ...CustomlinksInteracted };
    // gtmPushEvent('customlinksInteracted', { data: assign(CustomlinksInteractedData, defaultData, data) });
  };

  const eventDocumentDownload = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "documentType":"Download",
    //   "Action":"Download",
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // const DocumentDownloadData = { ...DocumentDownload };
    // gtmPushEvent('DocumentDownload', { data: assign(DocumentDownloadData, defaultData, data) });
  };

  const eventVideoInteracted = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "videoName": "",
    //   "videoState": "",
    //   "videoMileStone": "",
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // const VideoInteractedData = { ...VideoInteracted };
    // gtmPushEvent('VideoInteracted', { data: assign(VideoInteractedData, defaultData, data) });
  };

  const eventFormSubmit = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // gtmPushEvent('formSubmit', { data: assign(FormSubmit, defaultData, data) });
  };

  const eventSearchResultsCTA = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // const SearchResultsCTAData = { ...SearchResultsCTA };
    // gtmPushEvent('searchResultsCTA', { data: assign(SearchResultsCTAData, defaultData, data) });
  };

  const eventSearchResults = (data) => {
    // const { pageData } = usePageStore();
    // const defaultData = {
    //   "pageName": pageData.pageTitle,
    //   "pageUrl": decodeURI(route.value.fullPath),
    //   "pageCategory": pageData.pageCategory,
    // };
    // const SearchResultsData = { ...SearchResults };
    // gtmPushEvent('searchResults', { data: assign(SearchResultsData, defaultData, data) });
  };

  return {
    eventPageLoad,
    eventCustomlinksInteracted,
    eventDocumentDownload,
    eventVideoInteracted,
    eventFormSubmit,
    eventSearchResults,
    eventSearchResultsCTA,
  };
};

export default useGtm;
